import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { authContext } from "contexts/AuthContext";

const RequiredOnboarding = () => {
  const { data } = useContext(authContext).auth;
  const { super_admin_onboarding } = data;
  const { password, photo, contact } = data?.profile_status || {};

  if (super_admin_onboarding) {
    return <Navigate to="/super-admin-onboarding/step-1" />;
  } else if (password === 0 && photo === 0 && contact === 0) {
    return <Navigate to="/onboarding-reset-password" />;
  } else if (password === 1 && photo === 0 && contact === 0) {
    return <Navigate to="/onboarding-personal-details" />;
  } else if (password === 1 && photo === 1 && contact === 0) {
    return <Navigate to="/onboarding-contact-details" />;
  } else return <Outlet />;
};

export default RequiredOnboarding;
